/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.json.stringify.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { AddRegNoSchdule, QueryRegPrice } from "@/api";
import VisitChain from 'VisitChain';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { GETTER_APPTREG_ADDREGINFO, GETTER_CHAIN_SELECTVISITID, MUTATION_APPTREG_ADDREGINFO, GETTER_CHAIN_VISITLIST, GETTER_CLINICOBJ, ACTION_APPTREG_ADDREGNOSCHDULE } from '@/store/mutation_types';
import Cons from "Constant";
export default {
  data: function data() {
    return {
      intervalTime: '',
      scheduleSetName: '',
      schduleDate: '',
      schedulDoctorModel: 0,
      doctorDeptId: '',
      apptPayFlag: 0,
      descriptArea: '',
      regPrice: {},
      price: 0
    };
  },
  components: {
    VisitChain: VisitChain
  },
  created: function created() {
    if (this.addRegInfo) {
      this.intervalTime = this.addRegInfo.intervalTime;
      this.schduleDate = this.addRegInfo.schduleDate;
      this.scheduleSetName = this.addRegInfo.scheduleSetName;
      this.schedulDoctorModel = this.addRegInfo.schedulDoctorModel;
      this.doctorDeptId = this.addRegInfo.doctorDeptId;
      this.apptPayFlag = this.addRegInfo.apptPayFlag;
    }

    if (!this.addRegInfo) {
      Public.dialog({
        content: '请返回先选择预约信息'
      });
      return;
    }

    console.log('selectVisitId');

    if (this.selectVisitId) {
      this.QueryRegPriceAjax(this.selectVisitId);
    }
  },
  mounted: function mounted() {},
  watch: {
    visitList: function visitList() {
      this.QueryRegPriceAjax(this.selectVisitId);
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    selectVisitId: GETTER_CHAIN_SELECTVISITID,
    visitList: GETTER_CHAIN_VISITLIST,
    addRegInfo: GETTER_APPTREG_ADDREGINFO,
    clinicObj: GETTER_CLINICOBJ
  })), {}, {
    apptDateComp: function apptDateComp() {
      if (this.addRegInfo.noSchedules) {
        return "".concat(this.addRegInfo.apptDate, " \uFF08").concat(this.addRegInfo.startTime, " - ").concat(this.addRegInfo.endTime, "\uFF09");
      } else {
        return "".concat(this.schduleDate, " ").concat(this.intervalTime);
      }
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations({
    setAddRegInfo: MUTATION_APPTREG_ADDREGINFO
  })), mapActions({
    addRegNoSchdule: ACTION_APPTREG_ADDREGNOSCHDULE
  })), {}, {
    afterSelectVisit: function afterSelectVisit(data) {
      this.QueryRegPriceAjax(data.empiId);
    },
    afterAddVisit: function afterAddVisit() {
      this.$router.push({
        name: 'ChainVisitBind'
      });
    },
    addRegEvent: function addRegEvent(index) {
      var _this = this;

      var visit = this.visitList.find(function (e) {
        return e.empiId == _this.selectVisitId;
      });

      if (!visit) {
        Public.tips({
          text: "请选择就诊人"
        });
        return;
      }

      this.addRegAjax();
    },

    /**
     * 查询诊金
     * @param empiId
     * @constructor
     */
    QueryRegPriceAjax: function QueryRegPriceAjax(empiId) {
      var _this2 = this;

      console.log(empiId, this.apptPayFlag);

      if (!empiId || !this.apptPayFlag || this.apptPayFlag == '2') {
        return;
      }

      if (this.schedulDoctorModel == '2' && this.doctorDeptId) {
        QueryRegPrice(this.addRegInfo.doctorDeptId, empiId, this.addRegInfo.childClinicId).then(function (data) {
          _this2.regPrice = data;

          if (data.treatmentType == '1') {
            _this2.price = data.treatmentPrice;
          } else {
            _this2.price = data.reTreatmentPrice;
          }
        });
      }
    },

    /**
     * 新增预约-有排班
     */
    addRegAjax: function addRegAjax() {
      var _this3 = this;

      var visit = this.visitList.find(function (e) {
        return e.empiId == _this3.selectVisitId;
      });

      if (!visit) {
        return;
      }

      var childClinicId = this.addRegInfo.childClinicId;
      var clinicId = this.clinicObj.scrmClinic.clinicId;
      var visitInfo = {
        //大号才有visitId,小号为empId
        pEmpiId: visit.empiId,
        visitName: visit.patientName,
        visitMobile: visit.mobilePhoneNumber,
        visitGender: visit.patientGender,
        visitBirthday: visit.patientBirthDate
      };
      var apptInfo = {
        apptFlag: 0,
        apptDate: this.addRegInfo.schduleDate,
        apptSource: 'wx_scrm',
        apptRemark: this.descriptArea,
        startTime: this.addRegInfo.timeSpan.startTime,
        endTime: this.addRegInfo.timeSpan.endTime,
        doctorId: this.addRegInfo.doctorId || '',
        departmentId: this.addRegInfo.departmentId || '',
        memberName: visit.visitName || '',
        memberMobile: visit.visitMobile || '',
        memberId: visit.empiId || '',
        //诊金对应的诊疗项目
        treatmentId: this.regPrice.treatmentId,
        //治疗项目Name
        treatmentName: this.regPrice.treatmentName,
        //payPrice
        payPrice: this.price,
        //诊疗类型
        apptType: this.regPrice.treatmentType
      };
      var postData = JSON.stringify({
        clinicId: clinicId,
        childClinicId: childClinicId,
        visitInfo: visitInfo,
        apptInfo: apptInfo,
        scheduleId: this.addRegInfo.scheduleId,
        intervalInfo: [{
          intervalId: this.addRegInfo.timeSpan.intervalId
        }],
        plat: 'wx_scrm'
      });
      var param = {
        addRegInfo: this.addRegInfo,
        postData: postData,
        regPrice: this.regPrice
      };
      this.addRegNoSchdule(param).then(function () {
        if (_this3.price != 0) {
          var payPrice = _this3.price;

          if (Cons.ENV_DEBUG) {
            _this3.$router.push({
              name: 'PayApptPay',
              query: {
                apptRecordId: _this3.addRegInfo.apptRecordId,
                childClinicId: _this3.addRegInfo.childClinicId,
                payPrice: payPrice
              }
            });
          } else {
            var appId = Utils.getSessionCache(Cons.APPID);

            var _clinicId = Utils.getSessionCache(Cons.CLINIC_ID);

            var _childClinicId = _this3.addRegInfo.childClinicId;
            window.location.href = Cons.SCRM_PATH + "pay/apptPay?apptRecordId=".concat(_this3.addRegInfo.apptRecordId, "&appId=").concat(appId, "&clinicId=").concat(_clinicId, "&payPrice=").concat(payPrice, "&childClinicId=").concat(_childClinicId);
          }
        } else {
          Public.closeWin();
        }
      });
    },

    /**
    * 失去焦点  页面顶起不会弹
    */
    blurEvent: function blurEvent() {
      //IOS 虚拟键盘顶起内容不下
      if (Public.getSystemInfo().sysType === 1) {
        document.body.scrollTop = 0;
      }
    }
  })
};